import { Dictionary } from '@ngrx/entity';
import { FieldsState } from './fields-state.model';
import { FilterSearchOverlap } from './filter-search-overlap';
import { SearchableData } from './searchable-data';

export interface SearchState {
  searchedValue: string;
  searchableData: Dictionary<SearchableData>;
  searchOverlaps: Dictionary<FilterSearchOverlap>;
  searchFilteredDataIds: string[];
  shouldCalculateOnDataChange: boolean;
}

export declare type SortDirectionType = 'ASC' | 'DSC';

export const SortDirectionEnum = {
  ASC: 'ASC' as SortDirectionType,
  DSC: 'DSC' as SortDirectionType,
};

export interface SortState {
  sortDirection: SortDirectionType;
  sortOptionId: string;
  previousOrderedDataIds: string[];
  orderedDataIds: string[];
  shouldCalculateOnDataChange: boolean;
}

export interface FilterState {
  fieldDataLoadingState: Dictionary<boolean>;
  dataToFilter: Dictionary<any>;
  filteredDataIds: string[];
  fieldsState: FieldsState;
  isInitialized: boolean;
  isEmptyState: boolean;
}

export interface DataFilterInstanceState {
  filterState: FilterState;
  searchState: SearchState;
  sortState: SortState;
  queryParamsDisabled: boolean;
}
